<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('paymentByservice.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('paymentByservice.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('paymentByservice.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{
                        $t('paymentByservice.branchName')
                      }}</label>
                      <a-select style="width: 100%" v-model="model.branch_id" mode="multiple" :options="branches"
                        @change="onBranchChange" placeholder="All"></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('paymentByservice.feeType') }}</label>
                      <treeselect :options="fee_types" :placeholder="$t('all')" :multiple="true" :limit="1"
                        v-model="model.fee_type_id" @input="onFeeTypeChange"></treeselect>

                      <div class="validate" v-if="errors.has('fee_type_id')">
                        {{ errors.first('fee_type_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <div class="ts-flex ts-justify-between ts-text-right">
                        <label>{{ $t('paymentByservice.feeName') }}</label>
                        <ts-checkbox @change="selectAllFeeName">All</ts-checkbox>
                      </div>
                      <ts-loading-banner :loading="feeSetupLoading">
                        <treeselect :options="fee_setup" :placeholder="$t('all')" :multiple="true" :limit="1"
                          v-model="model.fee_setup_id"></treeselect>
                      </ts-loading-banner>
                      <div class="validate" v-if="errors.has('fee_setup_id')">
                        {{ errors.first('fee_setup_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('paymentByservice.date')
                      }}</label>
                      <a-range-picker style="width: 100%" v-model="model.date_range" format="DD-MM-YYYY"
                        valueFormat="YYYY-MM-DD" />
                      <div class="validate" v-if="errors.has('date_range')">
                        {{ errors.first('date_range') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label>{{
                        $t('studentEnrollmentReport.reportType')
                      }}</label>
                      <div class="form-group">
                        <div class="radio radio-css radio-inline">
                          <input v-model="model.report_type" type="radio" id="summary" :value="'Summary'" />
                          <label for="summary">
                            {{ $t('report.summary') }}
                          </label>
                        </div>
                        <div class="radio radio-css radio-inline">
                          <input v-model="model.report_type" type="radio" id="detail" :value="'Details'" />
                          <label for="detail">{{ $t('report.details') }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group" v-if="model.report_type == 'Details'">
                    <div class="col-md-12">
                      <label>{{ $t('paymentByservice.studentStatus') }}</label>
                      <treeselect :options="studentStatus.map(i => ({
                        id: i.status_id,
                        label: i.status
                      }))
                        " :placeholder="$t('all')" :multiple="true" :limit="1" v-model="model.status_id"
                        openDirection="top"></treeselect>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <div class="ts-flex ts-justify-between ts-space-x-2">
                        <a-button
                          class="ts-w-full ts-bg-green-500 ts-text-white hover:ts-border-green-500 hover:ts-text-green-500"
                          @click.prevent="onExcel" 
                          :loading="excel_waiting"
                        >
                          <i class="fas fa-file-excel"></i>
                        </a-button>
                        <a-button
                          class="ts-w-full"
                          type="danger" ghost 
                          @click.prevent="preview" 
                          :loading="waiting"
                        >
                          <i class="fas fa-file-pdf"></i>
                        </a-button>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('paymentByservice.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import * as FileDownload from 'downloadjs'
import { Errors } from 'form-backend-validation'
import { trim } from 'lodash'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'paymentByservice',
  data() {
    return {
      loading: false,
      excel_waiting: false,
      feeSetupLoading: false,
      waiting: false,
      src: '',
      errors: new Errors(),
      branches: [],
      fee_types: [],
      fee_setup: [],
      model: {
        report_type: 'Summary',
        fee_type_id: [],
        fee_setup_id: [],
        branch_id: null,
        status_id: [],
        date_range: [moment(), moment()]
      }
    }
  },
  computed: {
    ...mapState('reportPayment', ['studentStatus'])
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportPayment', [
      'byservice',
      'getBranch',
      'fetchFeeType',
      'fetchFeeSetup',
      'getStudentStatus',
      'byserviceExcel'
    ]),
    async fetchData() {
      this.loading = true
      await this.getStudentStatus()
      await this.fetchFeeType().then(response => {
        this.fee_types = response.data.map(el => ({
          id: el.fee_type_id,
          label: el.fee_type_name
        }))
      })
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.model.branch_id = this.$store.state.authUser.default_branch_id
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onFeeTypeChange() {
      this.feeSetupLoading = true
      this.fee_setup = []
      this.model.fee_setup_id = []
      if (this.model.fee_type_id.length <= 0) {
        this.feeSetupLoading = false
        return
      }

      this.fetchFeeSetup({
        branch_id: [this.model.branch_id],
        fee_type_id: this.model.fee_type_id

      })
        .then(response => {
          this.fee_setup = response.data.map(el => ({
            id: el.fee_setup_id,
            label: `${el.prefix}-${el.fee_name_en}`
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.feeSetupLoading = false
        })
    },
    onBranchChange() {
      this.model.fee_type_id = []
      this.model.fee_setup_id = []
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.byservice(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onExcel() {
      this.excel_waiting = true
      this.errors = new Errors()
      this.byserviceExcel(this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'.indexOf('filename')]
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.excel_waiting = false))
    },
    selectAllFeeName(id) {
      if (id) {
        this.fee_setup.forEach(el => {
          this.model.fee_setup_id.push(el.id)
        })
      } else {
        this.model.fee_setup_id = []
      }
    }
  }
}
</script>
